import { useMutation, useQueryClient } from 'react-query';
import { followUser, type FollowUserResponse } from '../../services/userService';

export function useFollowUser() {
  const queryClient = useQueryClient();
  return useMutation<FollowUserResponse, Error, { myProfileId: string; userProfileId: string }>(
    ({ myProfileId, userProfileId }) => followUser(myProfileId, userProfileId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['Posts']);
        queryClient.invalidateQueries(['users']);
      }
    }
  );
}
